
const mText = [
  "ഇന്നാണ് നിന്റെ ജീവിതത്തിലെ മറ്റൊരു മനോഹരമായ അധ്യായത്തിന്റെ തുടക്കം. ഇത് സ്നേഹത്തിലും, ചിരികളിലും, അനന്ത സാധ്യതകളിലും നിറഞ്ഞിരിക്കട്ടെ.",
  "മറ്റൊരു വയസ്സ് കൂടി, കൂടുതൽ ജ്ഞാനം, കൂടുതൽ മനോഹാരിത! നീ ഒരു അത്ഭുതമാണ്, അതിനാൽ നിനക്കൊപ്പം ഈ ദിനം ആഘോഷിക്കുന്നു.",
  "നിന്റെപോലെ അതിമനോഹരമായൊരു പിറന്നാൾ ആശംസിക്കുന്നു — സ്നേഹവും സന്തോഷവും നിന്റെ ഇഷ്ടങ്ങളെല്ലാം നിറഞ്ഞൊരു ദിവസം ആയിരിക്കട്ടെ.",
  "ജീവിതം ഒരു സമ്മാനമാണ്, നിന്റെ പിറന്നാൾ മറ്റൊരു വർഷം സ്വപ്നങ്ങളും സാഹസങ്ങളും അനുപമാന മുഹൂർത്തങ്ങളുമായി തുറക്കാൻ ഏറ്റവും അനുയോജ്യമായ സമയമാണ്.",
  "നിന്റെ പ്രത്യേകദിനത്തിൽ നിനക്കായി ഞാൻ ആശംസിക്കുന്നത് സന്തോഷം വർദ്ധിക്കട്ടെ, സ്വപ്നങ്ങൾ സാക്ഷാത്കാരമാകട്ടെ, ഓർമ്മകൾ ഒരിക്കലും മറക്കാനാകാത്തവയാകട്ടെ.",
  "പിറന്നാൾ ദിനങ്ങൾ കൂടുതൽ കേക്ക് കഴിക്കാൻ സൃഷ്ടിയുടെ രീതിയാണ്. മറ്റൊരു മധുരപരിപാടിയിലേക്ക് സ്വാഗതം!",
  "ജീവിതത്തിലെ ഈ പുതിയ വർഷം നിന്റെ സ്വപ്നങ്ങൾക്കു അടുത്ത് കൊണ്ടുപോകട്ടെ, നിന്റെ ഹൃദയം അപാരമായ സന്തോഷത്തോടെ നിറയട്ടെ.",
  "നിന്നെ അറിയുന്ന എല്ലാവർക്കും നീ തന്നെയൊരു സമ്മാനമാണ്. നിന്റെ പിറന്നാൾ നിനക്ക് നൽകുന്ന സന്തോഷം തിരിച്ചും നിനക്കായിരിക്കും.",
  "സൂര്യന്റെ ചുറ്റും മറ്റൊരു യാത്രയ്ക്കു സമയം. ഈ വർഷം നിന്റെ ഏറ്റവും അത്ഭുതകരമായ സാഹസമായിരിക്കട്ടെ.",
  "ഇന്നാം ദിവസം നിന്റെ പിറന്നാൾ മാത്രമല്ല, നീ എത്ര വലിയ വ്യക്തിയായി വളർന്നു എന്നും, നീ സ്പർശിച്ച ജീവിതങ്ങൾ എന്നും ആഘോഷിക്കപ്പെടുന്നു.",
  "നിന്റെ പിറന്നാൾ സന്തോഷത്തിലും ചിരിയിലും സാന്ദ്രമായ ഒരു പ്രകാശം പോലെയാകട്ടെ.",
  "ജീവിതം കണ്ണുനീർക്കാളിയല്ല, ചിരികളാലായിരിക്കട്ടെ. പ്രായം സംഖ്യയല്ല, സ്നേഹിതർ ആകട്ടെ. നിനക്ക് ഹൃദയത്തിൽ നിന്നും ജന്മദിനാശംസകൾ!",
  "നിന്റെ പിറന്നാൾ നീ എത്രമാത്രം സ്‌നേഹിക്കപ്പെടുന്നുവെന്നും, ആദരിക്കപ്പെടുന്നുവെന്നും ഓർമ്മപ്പെടുത്തുന്ന ദിവസം.",
  "ഈ പിറന്നാൾ നിന്റെ ജീവിതത്തിലെ ഏറ്റവും അത്ഭുതമായ വർഷത്തിന്റെയും അനുഗ്രഹങ്ങളുടെ തുടക്കമാകട്ടെ.",
  "ജീവിതം ആഘോഷിക്കപ്പെടേണ്ടതാണു — ഇന്ന് നിനക്ക് വേണ്ടി തന്നെ! നിന്റെ പിറന്നാൾ അത്യന്തം അതുല്യമായിരിക്കട്ടെ.",
  "നിന്റെ മെഴുകുതിരികൾ കത്തിക്കുമ്പോൾ, എല്ലാ ആഗ്രഹങ്ങളും നിറവേറട്ടെ, നിന്റെ ഹൃദയം അഴിമതമായ സന്തോഷത്താൽ നിറയട്ടെ."
];

export const birthdayQuotes = [
  {
    id: 1,
    text: "Today is the beginning of another beautiful chapter in your life. May it be filled with love, laughter, and endless possibilities.",
    background: "https://images.pexels.com/photos/1194420/pexels-photo-1194420.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-pink-400 to-purple-600",
    mtext: mText[0],
  },
  {
    id: 2,
    text: "Another year older, another year wiser, another year more fabulous! Here's to celebrating the amazing person you are.",
    background: "https://images.pexels.com/photos/1666065/pexels-photo-1666065.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-yellow-400 to-orange-500",
    mtext: mText[1],
  },
  {
    id: 3,
    text: "May your birthday be as wonderful as you are, filled with love, joy, and all your favorite things.",
    background: "https://images.pexels.com/photos/1729994/pexels-photo-1729994.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-blue-400 to-teal-600",
    mtext: mText[2],
  },
  {
    id: 4,
    text: "Life is a gift, and your birthday is the perfect time to unwrap another year of adventures, dreams, and beautiful moments.",
    background: "https://images.pexels.com/photos/1070968/pexels-photo-1070968.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-green-400 to-emerald-600",
    mtext: mText[3],
  },
  {
    id: 5,
    text: "On your special day, I wish you happiness that multiplies, dreams that come true, and memories that last forever.",
    background: "https://images.pexels.com/photos/1194420/pexels-photo-1194420.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-rose-400 to-pink-600",
    mtext: mText[4],
  },
  {
    id: 6,
    text: "Birthdays are nature's way of telling us to eat more cake and celebrate life. Here's to another year of sweetness!",
    background: "https://images.pexels.com/photos/1128678/pexels-photo-1128678.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-amber-400 to-yellow-600",
    mtext: mText[5],
  },
  {
    id: 7,
    text: "May this new year of your life bring you closer to your dreams and fill your heart with boundless joy.",
    background: "https://images.pexels.com/photos/1729994/pexels-photo-1729994.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-indigo-400 to-purple-600",
    mtext: mText[6],
  },
  {
    id: 8,
    text: "You are a gift to everyone who knows you. May your birthday be filled with the same joy you bring to others.",
    background: "https://images.pexels.com/photos/1666065/pexels-photo-1666065.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-cyan-400 to-blue-600",
    mtext: mText[7],
  },
  {
    id: 9,
    text: "Another trip around the sun deserves a celebration! May this year be your most amazing adventure yet.",
    background: "https://images.pexels.com/photos/1070968/pexels-photo-1070968.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-lime-400 to-green-600",
    mtext: mText[8],
  },
  {
    id: 10,
    text: "Today we celebrate not just your birthday, but the wonderful person you've become and all the lives you've touched.",
    background: "https://images.pexels.com/photos/1194420/pexels-photo-1194420.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-fuchsia-400 to-pink-600",
    mtext: mText[9],
  },
  {
    id: 11,
    text: "May your birthday sparkle with joy, shimmer with laughter, and glow with all the love surrounding you.",
    background: "https://images.pexels.com/photos/1128678/pexels-photo-1128678.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-orange-400 to-red-600",
    mtext: mText[10],
  },
  {
    id: 12,
    text: "Count your life by smiles, not tears. Count your age by friends, not years. Happy Birthday to someone truly special!",
    background: "https://images.pexels.com/photos/1729994/pexels-photo-1729994.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-violet-400 to-purple-600",
    mtext: mText[11],
  },
  {
    id: 13,
    text: "Your birthday is a reminder that you are loved, cherished, and appreciated more than you know.",
    background: "https://images.pexels.com/photos/1666065/pexels-photo-1666065.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-teal-400 to-cyan-600",
    mtext: mText[12],
  },
  {
    id: 14,
    text: "May this birthday mark the beginning of the most incredible year of your life, filled with blessings and beautiful surprises.",
    background: "https://images.pexels.com/photos/1070968/pexels-photo-1070968.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-emerald-400 to-teal-600",
    mtext: mText[13],
  },
  {
    id: 15,
    text: "Life is meant to be celebrated, and today we celebrate you! May your birthday be as extraordinary as you are.",
    background: "https://images.pexels.com/photos/1194420/pexels-photo-1194420.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-pink-400 to-rose-600",
    mtext: mText[14],
  },
  {
    id: 16,
    text: "As you blow out your candles, may all your wishes come true and your heart be filled with infinite happiness.",
    background: "https://images.pexels.com/photos/1128678/pexels-photo-1128678.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    theme: "gradient-to-br from-sky-400 to-indigo-600",
    mtext: mText[15],
  }
];

